'use es6';

export { getWindow as ownerWindow } from '@floating-ui/utils/dom';
export function ownerDocument(node) {
  return (node === null || node === void 0 ? void 0 : node.ownerDocument) || document;
}